<div class="flex flex-col gap-3" [formGroup]="form()">
  <div class="flex flex-col">
    <span class="text-lg">{{ 'pages.campaignForm.sections.notes.title' | translate }}</span>
    <div class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.notes.description' | translate }}
    </div>
  </div>
  <quill-editor
    class="custom-quill-editor"
    formControlName="notes"
    [placeholder]="'pages.campaignForm.sections.notes.placeholder' | translate"
  />

  @if (form().get('notes')?.errors !== null && form().get('notes')?.errors !== {}) {
    <mat-error [control]="form().get('notes')" />
  }
</div>
